import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import Footer from 'flarum/forum/components/Footer';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import Select from 'flarum/common/components/Select';
import IndexPage from 'flarum/forum/components/IndexPage';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import GlobalSearchState from 'flarum/forum/states/GlobalSearchState';
import SublaceFooter from './components/SublaceFooter';
import StatusModal from './components/StatusModal';
import addAutoRegister from './autoRegister';
import addProfiles from './profiles';
import { sublace, statuses, statusOf, StatusLabel, configForTag, configForTags, linkAttrs } from '../common/sublace';
export { default as extend } from './extend';
app.initializers.add('sublace-forum', () => {
  addHeader();
  addFooter();
  addStatuses();
  addStatusFilter();
  addComposerTemplates();
  addSectionNotice();
  addAutoRegister();
  addProfiles();
});

// ---------------------------------------------------------------- шапка

function addHeader() {
  extend(HeaderPrimary.prototype, 'items', function (items) {
    const config = sublace();
    items.add('sublace-forums', m(LinkButton, {
      className: "Button Button--link SublaceNav",
      href: app.route('sublace.forums'),
      icon: "fas fa-th-large"
    }, "\u0424\u043E\u0440\u0443\u043C\u044B"), 100);
    items.add('sublace-new', m(LinkButton, {
      className: "Button Button--link SublaceNav",
      href: app.route('index'),
      icon: "fas fa-bolt"
    }, "\u0427\u0442\u043E \u043D\u043E\u0432\u043E\u0433\u043E"), 90);
    if (app.forum.attribute('canSeeUserDirectoryLink') && app.routes.fof_user_directory) {
      items.add('sublace-users', m(LinkButton, {
        className: "Button Button--link SublaceNav",
        href: app.route('fof_user_directory'),
        icon: "fas fa-users"
      }, "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438"), 80);
    }
    (config.navLinks || []).forEach((link, i) => {
      const {
        external,
        ...attrs
      } = linkAttrs(link);
      items.add('sublace-link-' + i, m("a", Object.assign({
        className: "Button Button--link SublaceNav"
      }, attrs), link.icon ? m(Icon, {
        name: link.icon,
        className: "Button-icon"
      }) : null, m("span", {
        className: "Button-label"
      }, link.label), link.newTab && external ? m(Icon, {
        name: "fas fa-external-link-alt",
        className: "SublaceNav-ext"
      }) : null), 70 - i);
    });
    if (config.discordUrl) {
      items.add('sublace-discord', m("a", {
        className: "Button Button--link SublaceNav SublaceNav--discord",
        href: config.discordUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, m(Icon, {
        name: "fab fa-discord",
        className: "Button-icon"
      }), m("span", {
        className: "Button-label"
      }, "Discord")), 40);
    }
  });
}
function addFooter() {
  override(Footer.prototype, 'view', function () {
    return m(SublaceFooter, null);
  });
}

// --------------------------------------------------------------- статусы

function addStatuses() {
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const status = statusOf(this.attrs.discussion.sublaceStatus());
    if (status) items.add('sublaceStatus', m(StatusLabel, {
      status: status,
      small: true
    }), 20);
  });
  extend(DiscussionHero.prototype, 'items', function (items) {
    const status = statusOf(this.attrs.discussion.sublaceStatus());
    if (status) items.add('sublaceStatus', m(StatusLabel, {
      status: status
    }), 6);
  });
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (discussion.canSublaceStatus && discussion.canSublaceStatus() && statuses().length) {
      const current = statusOf(discussion.sublaceStatus());
      items.add('sublaceStatus', m(Button, {
        icon: "fas fa-clipboard-check",
        onclick: () => app.modal.show(StatusModal, {
          discussion
        })
      }, current ? 'Статус: ' + current.label : 'Назначить статус'), 110);
    }
  });
}

/** ?status=pending в адресе раздела — фильтр тем по статусу. */
function addStatusFilter() {
  extend(GlobalSearchState.prototype, 'params', function (params) {
    const status = m.route.param('status');
    if (status) params.status = status;
  });
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (this.params.status) {
      params.filter = params.filter || {};
      params.filter.sublaceStatus = this.params.status;
    }
  });
  extend(IndexPage.prototype, 'viewItems', function (items) {
    const tag = app.currentTag && app.currentTag();
    const config = configForTag(tag);
    const list = statuses();
    if (!list.length || !config && !m.route.param('status') || config && !config.statuses) return;
    const options = {
      '': 'Все статусы'
    };
    list.forEach(s => options[s.key] = s.label);
    items.add('sublaceStatus', m(Select, {
      className: "SublaceStatusFilter",
      options: options,
      value: m.route.param('status') || '',
      onchange: value => {
        const params = {
          ...app.search.state.params()
        };
        if (value) params.status = value;else delete params.status;
        m.route.set(app.route(app.current.get('routeName') || 'index', params));
      }
    }), 5);
  });
}

// --------------------------------------------------------- шаблоны тем

function addComposerTemplates() {
  const apply = function () {
    const fields = this.composer.fields;
    if (!fields || typeof fields.content !== 'function') return;
    const config = configForTags(fields.tags || []);
    const key = config ? String(config.tag.id()) : '';
    if (key === this.sublaceTemplateKey) return;
    const content = fields.content() || '';
    const prevTemplate = this.sublaceTemplateText || '';
    this.sublaceTemplateKey = key;

    // Не трогаем текст, который человек уже начал писать.
    if (content.trim() !== '' && content !== prevTemplate) return;
    const text = config && config.template ? config.template : '';
    this.sublaceTemplateText = text;
    if (content !== text) {
      fields.content(text);

      // Редактор может появиться позже (загружается асинхронно) — дожидаемся его.
      const composer = this.composer;
      let tries = 0;
      const sync = () => {
        const el = composer.editor && composer.editor.el;
        if (el && document.body.contains(el)) {
          if (el.value !== fields.content()) {
            el.value = fields.content();
            el.dispatchEvent(new Event('input', {
              bubbles: true
            }));
          }
          return;
        }
        if (tries++ < 40) setTimeout(sync, 50);
      };
      sync();
    }
    const titleTemplate = config && config.titleTemplate ? config.titleTemplate : '';
    const title = this.title ? this.title() : '';
    if (this.title && (!title || title === (this.sublaceTitleText || ''))) {
      this.sublaceTitleText = titleTemplate;
      this.title(titleTemplate);
    }

    // Курсор — в заголовок, после шаблонной части.
    setTimeout(() => {
      const input = this.element && this.element.querySelector('.DiscussionComposer-title');
      if (input && titleTemplate) {
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
      }
    }, 0);
    m.redraw();
  };
  extend('flarum/forum/components/DiscussionComposer', 'oncreate', apply);
  extend('flarum/forum/components/DiscussionComposer', 'onupdate', apply);
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    const config = configForTags(this.composer.fields.tags || []);
    if (config && config.notice) {
      items.add('sublaceNotice', m("div", {
        className: "SublaceComposerNotice",
        title: config.notice
      }, m(Icon, {
        name: "fas fa-info-circle"
      }), " ", config.notice), -10);
    }
  });
}

/** Подсказка «как подать» над списком тем раздела. */
function addSectionNotice() {
  extend(IndexPage.prototype, 'contentItems', function (items) {
    const tag = app.currentTag && app.currentTag();
    const config = configForTag(tag);
    if (config && config.notice) {
      items.add('sublaceNotice', m("div", {
        className: "SublaceSectionNotice",
        style: {
          '--tag-color': tag.color() || 'var(--sl-violet)'
        }
      }, m(Icon, {
        name: "fas fa-info-circle"
      }), m("div", null, m("strong", null, "\u041F\u0435\u0440\u0435\u0434 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043C \u0442\u0435\u043C\u044B"), m("p", null, config.notice))), 110);
    }
  });

  // Кнопка «Создать тему» на странице раздела подписывается по-человечески.
  extend(IndexSidebar.prototype, 'items', function (items) {
    const tag = app.currentTag && app.currentTag();
    const config = configForTag(tag);
    const button = items.has('newDiscussion') && items.get('newDiscussion');
    if (config && config.template && button && button.attrs && !button.attrs.disabled) {
      button.children = config.statuses ? 'Подать по форме' : 'Создать тему';
    }
  });
}